import React, {useRef, useState} from 'react';
import {Button} from 'antd';
import {FolderAddOutlined, UploadOutlined, FolderOpenOutlined} from '@ant-design/icons';
import './index.scss';

interface FloatingActionProps {
  onCreateFolder: () => void;
  onUploadFile: () => void;
  onUploadFolder: () => void;
}

export function FloatingAction({onCreateFolder, onUploadFile, onUploadFolder}: FloatingActionProps) {
  const [open, setOpen] = useState(false);
  const closeTimerRef = useRef<any>(null);

  function handleMouseEnter() {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
    }

    setOpen(true);
  }

  function handleMouseLeave() {
    closeTimerRef.current = setTimeout(() => {
      setOpen(false);
    }, 180);
  }

  function handleAction(callback: () => void) {
    callback();
    setOpen(false);
  }

  return (
    <div
      className="drive-floating-action"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/*展开菜单*/}
      {open && (
        <div className="drive-floating-action__menu-wrap">
          <div className="drive-floating-action__menu">
            <Button
              className="drive-floating-action__item"
              icon={<FolderAddOutlined/>}
              onClick={() => handleAction(onCreateFolder)}
            >
              新建文件夹
            </Button>

            <Button
              className="drive-floating-action__item"
              icon={<UploadOutlined/>}
              onClick={() => handleAction(onUploadFile)}>
              上传文件
            </Button>

            <Button
              className="drive-floating-action__item"
              icon={<FolderOpenOutlined/>}
              onClick={() => handleAction(onUploadFolder)}>
              上传文件夹
            </Button>
          </div>
        </div>
      )}

      {/*主按钮*/}
      <div
        className={`
          drive-floating-action__main
          ${open ? ' drive-floating-action__main--open' : ''}
        `}
      >
        <span className="drive-floating-action__main__icon">+</span>
      </div>
    </div>
  );
}